/* eslint-disable global-require */

export default {
    default: {
        ReferenceFront: require('./app-front/default.scss'),
        PlussFront: require('./pluss-front/default.scss'),
        Article: require('./article/default.scss'),
        Collection: require('./collection/default.scss'),
        AboutVG: require('./aboutvg/default.scss'),
        '@spp/ui-text': require('../../themes/ui-text/styles/default.scss'),
        '@spp/skip-to-content': require('../../themes/ui-skip-to-content/styles/default.scss'),
        '@spp/ui-article': require('../../themes/ui-article/styles/default.scss'),
        '@spp/ui-article-list': require('../../themes/ui-article-list/styles/default.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/default.scss'),
        '@spp/ui-carousel': require('../../themes/ui-carousel/styles/default.scss'),
        '@spp/ui-embed-content': require('../../themes/ui-embed-content/styles/default.scss'),
        '@spp/ui-factbox': require('../../themes/ui-factbox/styles/default.scss'),
        '@spp/ui-gallery': require('../../themes/ui-gallery/styles/gallery/default.scss'),
        '@spp/ui-gallery:image': require('../../themes/ui-gallery/styles/image/default.scss'),
        '@spp/ui-grade': require('../../themes/ui-grade/styles/default.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/default.scss'),
        '@spp/ui-image': require('../../themes/ui-image/styles/default.scss'),
        '@spp/ui-label': require('../../themes/ui-label/styles/default.scss'),
        '@spp/ui-lead-text': require('../../themes/ui-lead-text/styles/default.scss'),
        '@spp/ui-list': require('../../themes/ui-list/styles/default.scss'),
        '@spp/ui-map': require('../../themes/ui-map/styles/default.scss'),
        '@spp/ui-share': require('../../themes/ui-share/styles/default.scss'),
        '@spp/ui-share:svg': require('../../themes/ui-svg/styles/default.scss'),
        '@spp/ui-subheading': require('../../themes/ui-subheading/styles/default.scss'),
        '@spp/ui-subtitle': require('../../themes/ui-subtitle/styles/default.scss'),
        '@spp/video-asset': require('../../themes/video-asset/styles/default.scss'),
        '@spp/inline-video': require('../../themes/ui-inline-video/styles/default.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/default.scss'),
        '@spp/ui-teaser-small': require('../../themes/ui-teaser-small/styles/default.scss'),
        '@vg/ui-contact-us': require('../../themes/ui-contact-us/styles/default.scss'),
        '@vg/ui-url': require('../../themes/ui-url/styles/default.scss'),
        '@vg/coupon-codes': require('../../themes/coupon-codes/styles/default.scss'),
        '@vg/gold-competition': require('../../themes/vg-gold-competition/default.scss'),
        '@vg/ui-embed-wrapper': require('../../themes/ui-embed-wrapper/styles/default.scss'),
        '@vg/editorial-label': require('../../themes/ui-editorial-label/styles/default.scss'),
        '@vg/fb-comments': require('../../themes/ui-fb-comments/styles/default.scss'),
        '@vg/feedback': require('../../themes/ui-feedback/styles/default.scss'),
        '@vg/footer': require('../../themes/footer/styles/default.scss'),
        '@vg/publication-timestamp': require('../../themes/ui-timestamp/styles/default.scss'),
        '@vg/tags': require('../../themes/ui-tags/styles/default.scss'),
        '@vg/top-object': require('../../themes/ui-top-object/styles/default.scss'),
        '@vg/map-mapbox': require('../../themes/map-mapbox/styles/default.scss'),
        '@vg/generic-error': require('./error/default.scss'),
        '@vg/salesposter': require('../../themes/salesposter/styles/default.scss'),
        '@vg/external-articles': require('../../themes/ui-external-articles/styles/default.scss'),
        '@spp/ui-core-navigation': require('@vg/cn-skin-vg/styles/components/CoreNavigation.scss'),
        '@spp/cn-login-button': require('@vg/cn-skin-vg/styles/components/LoginButton.scss'),
        '@spp/cn-subscribe-button': require('@vg/cn-skin-vg/styles/components/SubscribeButton.scss'),
        '@spp/cn-chevron-down-main-menu': require('@spp/cn-skin-core/styles/svg/Chevron.scss'),
        '@spp/cn-chevron-down-masthead-extension': require('@spp/cn-skin-core/styles/svg/Chevron.scss'),
        '@spp/cn-chevron-left': require('@spp/cn-skin-core/styles/svg/ChevronLeft.scss'),
        '@spp/cn-logo': require('@vg/cn-skin-vg/styles/svg/Logo.scss'),
        '@spp/cn-main-menu': require('@vg/cn-skin-vg/styles/components/MainMenu.scss'),
        '@spp/cn-masthead': require('@vg/cn-skin-vg/styles/components/Masthead.scss'),
        '@spp/cn-masthead-extension': require('@vg/cn-skin-vg/styles/components/MastheadExtension.scss'),
        '@spp/cn-masthead-extension-basic-view': require('@vg/cn-skin-vg/styles/components/MastheadExtensionBasicView.scss'),
        '@spp/cn-masthead-extension-section-view': require('@vg/cn-skin-vg/styles/components/MastheadExtensionSectionView.scss'),
        '@spp/cn-masthead-search': require('@spp/cn-skin-core/styles/svg/MastheadSearch.scss'),
        '@spp/cn-search': require('@vg/cn-skin-vg/styles/components/Search.scss'),
        '@spp/cn-sitemap': require('@vg/cn-skin-vg/styles/components/SiteMap.scss'),
        '@spp/cn-user-menu': require('@vg/cn-skin-vg/styles/components/UserMenu.scss'),
        '@spp/cn-masthead-extension-subscription-buttons': require('@vg/cn-skin-vg/styles/components/MastheadExtensionSubscriptionButtons.scss'),
        '@spp/cn-masthead-extension-widgets': require('@vg/cn-skin-vg/styles/components/MastheadExtensionWidgets.scss'),
        '@spp/cn-user-logged-in-button': require('@spp/cn-skin-core/styles/svg/UserLoggedInButton.scss'),
        '@spp/cn-logged-in-badge': require('@vg/cn-skin-vg/styles/components/LoggedInBadge.scss'),
        '@vg/ui-nt-disclaimer': require('../../themes/ui-nt-disclaimer/styles/default.scss'),
        '@vg/ui-nt-bundle': require('../../themes/ui-nt-bundle/styles/default.scss'),
        '@vg/ui-video-paywall-overlay': require('../../themes/ui-video-paywall-overlay/styles/default.scss'),
    },
    sportnews: {
        Article: require('./article/sports.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/sports.scss'),
        '@spp/ui-carousel': require('../../themes/ui-carousel/styles/sports.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/sports.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/sports.scss'),
        '@spp/ui-article-list': require('../../themes/ui-article-list/styles/sports.scss'),
        '@spp/ui-teaser-small': require('../../themes/ui-teaser-small/styles/sports.scss'),
        '@vg/ui-nt-bundle': require('../../themes/ui-nt-bundle/styles/sports.scss'),
        '@vg/tags': require('../../themes/ui-tags/styles/sports.scss'),
    },
    sportfeature: {
        Article: require('./article/sportsfeature.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/sportsfeature.scss'),
        '@spp/ui-carousel': require('../../themes/ui-carousel/styles/sports.scss'),
        '@spp/ui-gallery': require('../../themes/ui-gallery/styles/gallery/feature.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/sportsfeature.scss'),
        '@spp/ui-image': require('../../themes/ui-image/styles/feature.scss'),
        '@spp/ui-lead-text': require('../../themes/ui-lead-text/styles/feature.scss'),
        '@spp/ui-map': require('../../themes/ui-map/styles/feature.scss'),
        '@spp/ui-subheading': require('../../themes/ui-subheading/styles/feature.scss'),
        '@spp/ui-subtitle': require('../../themes/ui-subtitle/styles/feature.scss'),
        '@spp/inline-video': require('../../themes/ui-inline-video/styles/feature.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/feature.scss'),
        '@spp/ui-teaser-small': require('../../themes/ui-teaser-small/styles/sports.scss'),
        '@spp/ui-article-list': require('../../themes/ui-article-list/styles/sports.scss'),
        '@vg/ui-nt-bundle': require('../../themes/ui-nt-bundle/styles/sports.scss'),
        '@vg/publication-timestamp': require('../../themes/ui-timestamp/styles/feature.scss'),
        '@vg/tags': require('../../themes/ui-tags/styles/sports.scss'),
    },
    /* all of these are the same, so add new items to all categories */
    nyheterfeature: {
        Article: require('./article/feature.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/feature.scss'),
        '@spp/ui-gallery': require('../../themes/ui-gallery/styles/gallery/feature.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/feature.scss'),
        '@spp/ui-image': require('../../themes/ui-image/styles/feature.scss'),
        '@spp/ui-lead-text': require('../../themes/ui-lead-text/styles/feature.scss'),
        '@spp/ui-map': require('../../themes/ui-map/styles/feature.scss'),
        '@spp/ui-subheading': require('../../themes/ui-subheading/styles/feature.scss'),
        '@spp/ui-subtitle': require('../../themes/ui-subtitle/styles/feature.scss'),
        '@spp/inline-video': require('../../themes/ui-inline-video/styles/feature.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/feature.scss'),
        '@vg/publication-timestamp': require('../../themes/ui-timestamp/styles/feature.scss'),
    },
    rampelysfeature: {
        Article: require('./article/feature.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/feature.scss'),
        '@spp/ui-gallery': require('../../themes/ui-gallery/styles/gallery/feature.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/feature.scss'),
        '@spp/ui-image': require('../../themes/ui-image/styles/feature.scss'),
        '@spp/ui-lead-text': require('../../themes/ui-lead-text/styles/feature.scss'),
        '@spp/ui-map': require('../../themes/ui-map/styles/feature.scss'),
        '@spp/ui-subheading': require('../../themes/ui-subheading/styles/feature.scss'),
        '@spp/ui-subtitle': require('../../themes/ui-subtitle/styles/feature.scss'),
        '@spp/inline-video': require('../../themes/ui-inline-video/styles/feature.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/feature.scss'),
        '@vg/publication-timestamp': require('../../themes/ui-timestamp/styles/feature.scss'),
    },
    forbrukerfeature: {
        Article: require('./article/feature.scss'),
        '@spp/ui-blockquote': require('../../themes/ui-blockquote/styles/feature.scss'),
        '@spp/ui-gallery': require('../../themes/ui-gallery/styles/gallery/feature.scss'),
        '@spp/ui-headline': require('../../themes/ui-headline/styles/feature.scss'),
        '@spp/ui-image': require('../../themes/ui-image/styles/feature.scss'),
        '@spp/ui-lead-text': require('../../themes/ui-lead-text/styles/feature.scss'),
        '@spp/ui-map': require('../../themes/ui-map/styles/feature.scss'),
        '@spp/ui-subheading': require('../../themes/ui-subheading/styles/feature.scss'),
        '@spp/ui-subtitle': require('../../themes/ui-subtitle/styles/feature.scss'),
        '@spp/inline-video': require('../../themes/ui-inline-video/styles/feature.scss'),
        '@spp/ui-byline': require('../../themes/ui-byline/styles/feature.scss'),
        '@vg/publication-timestamp': require('../../themes/ui-timestamp/styles/feature.scss'),
    },
};
/* eslint-enable global-require */



/** WEBPACK FOOTER **
 ** ./src/theme/index.js
 **/